import { isTypeEmbedZohoForm } from '@platform/contentful';
import { Entry } from 'contentful';

const ContentfulEmbedZohoForm = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeEmbedZohoForm(entry)) {
    return null;
  }

  return (
    <div>
      {/* TODO: I'm assuming it's an iframe */}
      <iframe
        src={entry.fields.publicUrl ?? ''}
        width={entry.fields.width}
        height={entry.fields.height}
        /* TODO: There are a bunch of Zoom fields here */
      />
    </div>
  );
};

export default ContentfulEmbedZohoForm;
